import React, { Component } from 'react';
import { Form, Col } from 'react-bootstrap';

class Select3E extends Component {

    constructor(props) {
        super(props);
        this.select = this.select.bind(this);
    }

    select = (e) => {
        let vals = Array.from(e.target.selectedOptions).map(option => option.value);
        let val = vals;
        if (vals.length === 1) {
            val = vals[0];
        }
        this.props.setETag(val);
    }

    render() {
        return (
            <Col>
                <Form.Label>Engagement Experiences</Form.Label>
                <Form.Control as='select' htmlSize={3} custom onChange={this.select} >
                    {this.props.eTags.map(item =>
                        <option key={item.value} value={item.value} > {item.text}</option>
                    )}}
                </Form.Control>
            </Col>
        )
    }
}

export default Select3E;



// WEBPACK FOOTER //
// ./src/components/Search/FormFields/Select3E.js